import { Routes } from '@angular/router';
import { provideRouter } from '@angular/router';
import { HomeComponent } from './app/pages/home/home.component';
import { AboutComponent } from './app/pages/about/about.component';
import { ContactComponent } from './app/pages/contact/contact.component';
import { ServicesComponent } from './app/pages/services/services.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about-us', component: AboutComponent },
  { path: 'contact-us', component: ContactComponent },
  { path: 'departments', component: ServicesComponent }
];

export const AppRouting = provideRouter(routes);
